/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Not_FoundInputs */

const en_us2_account_not_found = /** @type {(inputs: Account_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not find an account with that email.`)
};

const pt_br2_account_not_found = /** @type {(inputs: Account_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não encontramos nenhuma conta com esse e-mail.`)
};

const es_419_account_not_found = /** @type {(inputs: Account_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No encontramos ninguna cuenta con ese correo.`)
};

const pt_pt2_account_not_found = /** @type {(inputs: Account_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não encontrámos nenhuma conta com esse e-mail.`)
};

const fr_fr2_account_not_found = /** @type {(inputs: Account_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun compte trouvé avec cet e-mail.`)
};

const de_de2_account_not_found = /** @type {(inputs: Account_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir haben kein Konto mit dieser E-Mail gefunden.`)
};

const it_it2_account_not_found = /** @type {(inputs: Account_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non abbiamo trovato nessun account con questa email.`)
};

/**
* | output |
* | --- |
* | "We could not find an account with that email." |
*
* @param {Account_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const account_not_found = /** @type {((inputs?: Account_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_account_not_found(inputs)
	if (locale === "es-419") return es_419_account_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_account_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_account_not_found(inputs)
	if (locale === "de-DE") return de_de2_account_not_found(inputs)
	if (locale === "it-IT") return it_it2_account_not_found(inputs)
	return en_us2_account_not_found(inputs)
});
export { account_not_found as "account.not_found" }